<template>
  <div>
    <base-title
      :title="StringLanguage.storeInformations"
      :subtitle="
        onBoardDone ? StringLanguage.configurations : StringLanguage.back
      "
      :link="onBoardDone ? 'configuracoes' : 'onboard'"
    >
    </base-title>

    <base-box class="mb_20">
      <base-label text="Informações da loja" class="mb_20" />
      <custom-form ref="form">
        <base-input
          :label="StringLanguage.nameRestaurant"
          v-model="company.name"
          :valid="userError !== 'name'"
          @focus="clearError('name')"
          @blur="validateName"
        />
        <email-input
          v-model="company.email"
          :label="StringLanguage.emailRestaurant"
          :required="false"
        />
        <telephone-input
          :label="StringLanguage.phone1Restaurant"
          v-model="company.phone1"
          :required="false"
        />
        <telephone-input
          :label="StringLanguage.phone2Restaurant"
          v-model="company.phone2"
          :required="false"
        />
        <base-textarea
          :label="StringLanguage.descriptionRestaurant"
          v-model="company.description"
          :rows="isMobile ? 10 : 5"
          :required="false"
        />
      </custom-form>
    </base-box>

    <base-box>
      <base-label text="Categorias da loja" class="mb_20" />
      <div class="row">
        <div
          class="col-lg-4 col-xs-12 categories"
          v-for="(category, i) in company.categories"
          :key="i"
        >
          <div class="env-type">
            <p class="type-name">{{ OriginalCategoryList[category].name }}</p>
          </div>
        </div>

        <div
          class="col-lg-4 col-md-6 col-xs-12"
          @click="
            drawerType = !drawerType;
            search.term = '';
            makeFocus();
          "
        >
          <p
            v-if="
              !company.categories ||
              company.categories.length <
                2 /* Se houver apenas um selecionado */
            "
            class="add-others"
          >
            <i class="fal fa-plus mr_15"></i>{{ StringLanguage.addCategory }}
          </p>
          <p v-else class="add-others">{{ StringLanguage.changeCategories }}</p>
        </div>
      </div>
    </base-box>

    <base-drawer title="Categorias da loja" :open="drawerType" :close="close">
      <base-card>
        <base-message design="gold"
          >Você pode escolher até no máximo duas categorias para seu
          estabelecimento.</base-message
        >
      </base-card>
      <base-card>
        <base-label text="Defina as categorias" id="search" />
        <base-input
          :placeholder="StringLanguage.search"
          class="mb_20 mt_15"
          :value="search.term"
          v-on:keyup="filterCategory"
          search
          ref="searchInput"
        />
        <div
          class="env-type-two"
          v-for="category in getCategoryList()"
          :key="category.alias"
        >
          <base-checkbox
            :label="category.name"
            v-model="category.checked"
            :checked="category.checked"
            @click="checkCategory(category, $event)"
          />
        </div>
      </base-card>

      <template v-slot:footer>
        <base-button
          text="Aplicar"
          class="w-100 big"
          @click="setCategories"
          :disabled="loadingData"
        />
      </template>
    </base-drawer>

    <div class="d-flex justify-end w-100 mt_5" v-if="hasChanges()">
      <base-button design="save" @click="onSave" :disabled="loadingData" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { TheMask } from 'vue-the-mask';
import Category from 'easyjs/lib/Schema/Category/index';
import Vue from 'vue';
import BasicInfo from '@/plugins/core/schema/configurations/BasicInfo/BasicInfo';
import StoreAPI from '@/api/store';
import { onBoardProgress } from '@/plugins/core/schema/onBoardEnum';

import CustomForm from '@/containers/Form.vue';
import EmailInput from '../../containers/Inputs/EmailInput';
import TelephoneInput from '../../containers/Inputs/TelephoneInput';

import BaseTitle from '@/components/Title';
import BaseButton from '@/components/Button';
import BaseBox from '@/components/Box';
import BaseInput from '@/components/Input';
import BaseTextarea from '@/components/Textarea';
import BaseLabel from '@/components/Label';
import BaseCheckbox from '@/components/Checkbox';
import BaseDrawer from '@/components/Drawer';
import BaseCard from '@/components/Card';
import BaseMessage from '@/components/Message';

export default {
  data() {
    return {
      loadingData: false,
      company: new BasicInfo(),
      OriginalCategoryList: [],
      categoryList: [],
      selectedCategories: [],
      search: {
        id: null,
        term: null,
        enable: false,
      },
      originalData: null,
      drawerType: false,
      close: false,
      userError: null,
    };
  },
  created() {
    const self = this;
    this.loadingData = true;
    StoreAPI.storeGetConfiguration('basic_info')
      .then((response) => {
        self.set(response);
        this.getCategories();

        // se ao entrar, estando no onboarding e com alguma informação preenchida, exibe alerta
        if (
          !this.onBoardDone &&
          this.company &&
          (this.company.email ||
            this.company.phone1 ||
            this.company.phone2 ||
            this.company.description) &&
          this.company &&
          (!this.company.name || !this.company.categories.length)
        ) {
          alert(StringLanguage.infoAndCategoryRequired);
        }
      })
      .catch((err) => {
        console.log(err);
        alert(StringLanguage.loadError);
      })
      .finally(() => {
        this.loadingData = false;
      });
  },
  beforeRouteLeave(to, from, next) {
    if (this.hasChanges()) {
      confirm(`${StringLanguage.confirmComplement}`, (res) => {
        if (res) next();
      });
    } else {
      next();
    }
  },
  methods: {
    makeFocus() {
      this.$nextTick(function () {
        this.$refs.searchInput.focus();
      });
    },
    hasChanges() {
      return JSON.stringify(this.originalData) !== JSON.stringify(this.company);
    },
    onSave() {
      if (
        !this.company.name ||
        !this.company.categories ||
        (this.company.categories && this.company.categories.length === 0)
      ) {
        alert(StringLanguage.confirmInfoRequired);
        return;
      }
      // ao sair, com o onboarding concluído, estando sem alguma informação requerida, exibe confirm
      if (
        this.onBoardDone &&
        this.company &&
        (!this.company.name || !this.company.categories.length)
      ) {
        alert(StringLanguage.confirmInfoWithoutLeaveRoute);

        if (!this.company.name) {
          this.userError = 'name';
        }
      } else {
        // se está com informações editadas mas as requeridas estão presentes, salva
        if (this.hasChanges()) {
          if (this.isInputsValid()) {
            this.save();
          }
        } else {
          alert(StringLanguage.noChanges);
        }
      }
    },
    isInputsValid() {
      this.$refs.form.validateInputs();

      const isInputsValids = !this.$refs.form.messages.length;

      return isInputsValids;
    },
    clearError(prop) {
      if (this.userError === prop) this.userError = null;
    },
    set(response) {
      if (response.getErrors([]).length > 0) {
        alert(response.getErrors([StringLanguage.loadError])[0]);
        return false;
      }
      if (response.getData({}).basic_info || false) {
        const company = response.getData(new BasicInfo()).basic_info;

        Vue.set(
          this,
          'company',
          new BasicInfo(
            company.name,
            company.email,
            company.phone1,
            company.phone2,
            company.description,
            company.categories
          )
        );
        Vue.set(
          this,
          'originalData',
          new BasicInfo(
            company.name,
            company.email,
            company.phone1,
            company.phone2,
            company.description,
            company.categories
          )
        );
      } else {
        Vue.set(this, 'company', new BasicInfo());
        Vue.set(this, 'originalData', new BasicInfo());
      }
    },
    closeDrawer() {
      this.close = !this.close;
    },
    setCategories() {
      this.company.categories = this.selectedCategories;
      this.closeDrawer();
    },
    validateName() {
      if (this.company.name.length > 45) {
        this.userError = 'name';
        this.loadingData = false;
        return false;
      }
      return true;
    },
    save() {
      if (!this.validateName()) {
        return;
      }
      const self = this;
      this.loadingData = true;

      if (this.onBoardDone) {
        if (!this.company.name) {
          alert(StringLanguage.errorNameRequired);
          this.userError = 'name';
          this.loadingData = false;
          return;
        }

        if (this.selectedCategories.length < 1) {
          alert(StringLanguage.errorMinCategories);
          this.loadingData = false;
          return;
        }
      }
      return StoreAPI.storeConfiguration({
        basic_info: this.company,
      })
        .then((response) => {
          if (response.getErrors([]).length == 0) {
            this.$store.dispatch('store/getConfigurations');
            self.set(response);

            if (!this.onBoardDone) {
              return this.$router.push({ name: 'onboard' });
            }

            alert(StringLanguage.saveSuccess);
          }
        })
        .catch((err) => {
          console.log(err);
          alert(StringLanguage.saveError);
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    getCategories() {
      this.OriginalCategoryList = Category.getAllCategories();

      for (const i in this.OriginalCategoryList) {
        let selected = false;
        if (this.company.categories && this.company.categories.length > 0) {
          selected = this.company.categories.filter(
            (a) => a == this.OriginalCategoryList[i].alias
          )[0];
        }

        if (selected) this.selectedCategories.push(selected);

        this.categoryList.push({
          alias: this.OriginalCategoryList[i].alias,
          name: this.OriginalCategoryList[i].name,
          checked: !!selected,
        });
      }
    },
    getCategoryList() {
      const filteredCategories = [...this.filterItems(this.categoryList)];

      return filteredCategories.sort((a, b) => {
        return b.checked - a.checked;
      });
    },
    filterItems(items) {
      if (!this.search.term) {
        return items;
      }

      const searchTerm = this.search.term.toLowerCase();
      return (items || []).filter((i) => {
        if (this.isValidTerm(searchTerm, i.name.toLowerCase())) return true;
        if (this.filterItems(i.items).length > 0) return true;
      });
    },
    isValidTerm(searchTerm, term) {
      return term.indexOf(searchTerm) > -1;
    },
    checkCategory(category, event) {
      if (category.checked) {
        return (this.selectedCategories = this.selectedCategories.filter(
          (x) => x != category.alias
        ));
      }

      if (this.selectedCategories.length < 2) {
        const elm = document.getElementById(`search`);
        if (elm) {
          elm.scrollIntoView({ behavior: 'smooth' });
        }

        return this.selectedCategories.push(category.alias);
      }

      event.preventDefault();
      alert(StringLanguage.errorMaxCategories);
    },
    filterCategory(e) {
      if (this.search.id) {
        clearTimeout(this.search.id);
      }

      this.search.id = setTimeout(() => {
        this.search.term = e.target.value;
      }, 300);
    },
    clearFilter() {
      if (this.search.id) {
        clearTimeout(this.search.id);
      }
      this.search.term = null;
    },
  },
  computed: {
    ...mapState({
      storeConfiguration: (state) => state.store.configurations,
      isMobile: (state) => state.store.isMobile,
      onBoardDone: (state) => state.store.onBoardDone,
    }),
  },
  components: {
    TheMask,
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseInput,
    BaseTextarea,
    BaseLabel,
    BaseCheckbox,
    BaseDrawer,
    BaseCard,
    BaseMessage,
    EmailInput,
    TelephoneInput,
    CustomForm,
  },
};
</script>
<style scoped>
.env-type {
  padding: 15px 25px;
  display: flex;
  align-items: center;
  background: var(--box-up);
  border-radius: 5px;
  height: 46px;
}

.env-type-two {
  padding: 20px;
  display: flex;
  align-items: center;
  background: var(--box-up);
  border-radius: 5px;
  margin-bottom: 15px;
}

.type-name {
  font-size: 1.4em;
  color: var(--label-primary);
  font-weight: bold;
}

.add-others {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4em;
  padding: 15px;
  height: 46px;
  font-weight: bold;
  border: 2px dashed #676b73;
  border-radius: 5px;
  cursor: pointer;
  color: var(--label-primary);
  opacity: 0.8;
  transition: all 0.1s ease;
}

.add-others:hover {
  filter: brightness(1.1);
}

@media screen and (max-width: 991px) {
  .categories {
    margin-bottom: 10px;
  }
}
</style>
